import React, { useState } from 'react'
import Icon from '@ant-design/icons'
import DataServices from '../../../Services/DataServices'
import IntlMessages from '../../../util/IntlMessages'
import {
  Table,
  Card,
  Col,
  Row,
  Button,
  Modal,
  Collapse,
  Tabs,
  message,
  Spin,
  Tag
} from 'antd'

import Skeleton from 'react-loading-skeleton'
import StockControl from '../../../assets/images/stock-control.png'
import { useHistory, useRouteMatch } from 'react-router'
import ds from '../../../Services/DataServices'
import { useDispatch, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import moment from 'moment'
import {
  getDecryptID,
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { INVENTORY_SCREEN } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { setCommonConfigs } from '../../../appRedux/actions'
import { stat } from 'fs'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'
const confirm = Modal.confirm
const InventoryGeneralStatuse = [
  {
    Key: 1,
    Name: 'DUE',
    DisplayName: 'products.inventoryCount.inventoryTab1'
  },
  {
    Key: 2,
    Name: 'UPCOMING',
    DisplayName: 'products.inventoryCount.inventoryTab2'
  },
  {
    Key: 3,
    Name: 'COMPLETED',
    DisplayName: 'products.inventoryCount.inventoryTab3'
  },
  {
    Key: 4,
    Name: 'CANCELLED',
    DisplayName: 'products.inventoryCount.inventoryTab4'
  }
]

const InventoryCountList = props => {
  const Panel = Collapse.Panel
  const { TabPane } = Tabs
  const history = useHistory()
  const { path, url } = useRouteMatch()
  const dispatch = useDispatch()

  //#region useState

  const [getInventoryListData, setInventoryListData] = React.useState([])
  const [getLoader, setLoader] = useState(false)
  const [getSpinLoader, setSpinLoader] = React.useState(false)
  const [getPagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10
  })
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getShortCurr, setShortCurr] = useState('')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  //#endregion useState
  //#region useSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  //#endregion useSelector

  //#region useEffect
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      dispatch(setCommonConfigs(INVENTORY_SCREEN))
      let inventoryObj = {
        InventoryStatusType: 'DUE',
        CurrentPageNo: 1,
        PageSize: 10
      }
      getInventoryListService(inventoryObj)
    }
    return () => (mounted = false)
  }, [])
  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
        setShortCurr(currencyData.currencyCode)
        setCurrData(currencyData)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  //#endregion useEffect

  //#region Api Services
  async function getInventoryListService (body, featureID) {
    setLoader(true)
    const getInventoryList = ds.getInventoryListData(
      body,
      BEHAVIOUR_TYPE.GET,
      featureID
    )
    await getInventoryList
      .then(response => {
        if (response) {
          let paginationObj = {
            current: body.CurrentPageNo,
            pageSize: getPagination.pageSize,
            total: response.length > 0 ? response[0].totalRecords : 0
          }
          setPagination(paginationObj)
          setInventoryListData(response)
          setLoader(false)
        }
      })
      .catch(e => {
        setLoader(false)
        notAllowMsgCheck(e)
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut("store.getState()"));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function postInvenotyCountService (body, featureID) {
    await ds
      .postInventoryCountData(body, BEHAVIOUR_TYPE.DELETE, featureID)
      .then(res => {
        setSpinLoader(true)
        if (res.data.data) {
          message.success('Inventory Count Deleted Successfully')
          let inventoryData = getInventoryListData.filter(
            e =>
              getDecryptID(e.inventoryTakeID) !=
              getDecryptID(body.InventoryTakeID)
          )
          setInventoryListData(inventoryData)
          setSpinLoader(false)
        } else {
          message.success('Inventory Count not Deleted, Please Try Again..!')
          setSpinLoader(false)
        }
      })
      .catch(error => {
        setSpinLoader(false)
        notAllowMsgCheck(error)
      })
  }
  //#endregion Api Services

  //#region Change Functions, OnClick Form Save
  const handleInventoryTabChange = obj => {
    let type = 'DUE'
    if (obj == 1) {
      type = 'DUE'
    }
    if (obj == 2) {
      type = 'UPCOMING'
    }
    if (obj == 3) {
      type = 'COMPLETED'
    }
    if (obj == 4) {
      type = 'CANCELLED'
    }
    let inventoryObj = {
      InventoryStatusType: type,
      CurrentPageNo: 1
    }
    getInventoryListService(inventoryObj, PkgFeatures.InventoryManagement)
    //send kro yahan sy type
  }

  const handleTableChange = (pagination, type) => {
    let body = {
      CurrentPageNo: pagination.current,
      InventoryStatusType: type
    }
    getInventoryListService(body, PkgFeatures.InventoryManagement)
  }
  const handleClickInventoryCount = paramRecord => {
    let statusName = paramRecord.statusName
    let id = paramRecord.inventoryTakeID
    let url = 'Dashboard/inventory/inventorycount/listing'
    if (
      statusName == 'Scheduled' ||
      statusName == 'UpComing' ||
      statusName == 'Over Due'
    ) {
      url = `/Dashboard/inventory/inventorycount/${id}/edit`
    }
    if (statusName == 'In Progress') {
      url = `/Dashboard/inventory/inventorycount/${id}/perform`
    }
    if (statusName == 'Completed' || statusName == 'Canceled') {
      url = `/Dashboard/inventory/inventorycount/${id}`
    }
    history.push(url)
  }
  //#endregion Change Functions, OnClick Form Save

  const columnsInventoryCountList = [
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventoryCountTableColumn1' />
      ),
      dataIndex: 'inventoryName',
      key: 'InventoryName',
      render: (text, record) => (
        <>
          <a
            onClick={() => handleClickInventoryCount(record)}
            className='gx-link'
          >
            <div>
              <Row style={{ textAlign: 'left' }}>
                <Col span={12} lg={24} md={24} sm={24} xs={24}>
                  <strong>
                    {record.inventoryName ? record.inventoryName : ''}
                  </strong>
                  <span
                    style={{ marginLeft: '5px' }}
                    className='vd-flag sm:hidden'
                  >
                    {record.statusName
                      ? record.statusName.toString().toUpperCase()
                      : ''}
                  </span>
                </Col>
              </Row>
              <Row style={{ textAlgin: 'left' }}>
                <Col span={12} lg={12} md={12} sm={12} xs={24}>
                  <span style={{ fontSize: 'small' }}>
                    <strong style={{ color: '#40a9ff' }}>
                      {moment(record.executedOn).fromNow()}
                    </strong>
                  </span>
                </Col>
              </Row>
            </div>
          </a>
        </>
      )
    },
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventoryCountTableColumn2' />
      ),
      dataIndex: 'outletName',
      key: 'OutletName'
    },
    {
      title: (
        <IntlMessages id='products.inventoryCount.inventoryCountTableColumn3' />
      ),
      dataIndex: 'countType',
      key: 'Count'
    },
    {
      key: 'edit',
      render: (text, record) => {
        return getIsDisableUpdate ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <>
            {record.statusName == 'Scheduled' ||
            record.statusName == 'UpComing' ||
            record.statusName == 'Over Due' ? (
              <span>
                <span
                  onClick={() => {
                    history.push(
                      `/Dashboard/inventory/inventorycount/${record.inventoryTakeID}/edit`
                    )
                  }}
                  className='pen-edit'
                >
                  <i className='icon icon-edit'> </i>
                </span>
              </span>
            ) : (
              ''
            )}
          </>
        )
      }
    },
    {
      //title: <IntlMessages id="products.productypes.delete" />,
      key: 'delete',
      render: (text, record) => {
        const deleteInventoryCount = async inventoryTakeID => {
          let body = {
            BehaviorName: 2,
            InventoryTakeID: inventoryTakeID
          }
          postInvenotyCountService(body, PkgFeatures.InventoryManagement)
        }
        function showDeleteConfirm (inventoryTakeID, inventoryName) {
          confirm({
            title: 'Are you sure delete this Inventory count?',
            content: `"${inventoryName}"`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { className: 'dk-btn-add close-reg-btn' },
            cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
            onOk () {
              deleteInventoryCount(inventoryTakeID)
            },
            onCancel () {
              //console.log('Cancel');
            }
          })
        }

        return getIsDisableDelete ? (
          <Tag color='#f50'>
            <strong>
              <IntlMessages id='dakarpos.allow.accessdenied' />
            </strong>
          </Tag>
        ) : (
          <>
            {record.statusName == 'Scheduled' ||
            record.statusName == 'UpComing' ||
            record.statusName == 'Over Due' ? (
              <span>
                <a
                  className='trash-icon-btn'
                  onClick={() =>
                    showDeleteConfirm(
                      record.inventoryTakeID,
                      record.inventoryName
                    )
                  }
                >
                  <i className='icon icon-trash' />
                </a>
              </span>
            ) : (
              ''
            )}
          </>
        )
      }
    }
  ]

  return (
    <>
      {getIsAllowRead && isFeatureAllowed ? (
        <div className='Content-wrapper InventoryCount-pg'>
          <Row className='align-items-center mb-3 RegisterClosureSummary-header'>
            <Col lg={12} md={12} sm={24} xs={24}>
              <h1 className='mb-0'>
                <IntlMessages id='products.inventoryCount.inventoryCountTitle' />
              </h1>
            </Col>

            <Col lg={12} md={12} sm={24} xs={24}>
              <div className='d-flex align-items-center justify-content-end'>
                <Button
                  type='primary'
                  size='large'
                  className='dk-btn-add'
                  onClick={() => {
                    console.log(path)
                    history.push(`/Dashboard/inventory/inventorycount/create`)
                  }}
                  disabled={getIsDisableCreate}
                >
                  <IntlMessages id='products.inventoryCount.addinventorycount' />
                </Button>
              </div>
            </Col>
          </Row>

          <Card className='gx-card' title=''>
            <Collapse>
              <Panel
                className='custom-promolist-help'
                showArrow={true}
                header={
                  <IntlMessages id='products.productypes.needhelpheading' />
                }
              >
                <Row>
                  <div className='billing-main'>
                    <Col className='custom-promolist-helpdesc' md={12}>
                      <p>
                        <IntlMessages id='products.inventoryCount.inventoryCountHelpDescription1' />
                      </p>
                    </Col>

                    <Col md={12}>
                      <img src={StockControl} alt='' />
                    </Col>
                  </div>
                </Row>
              </Panel>
            </Collapse>
          </Card>
          <Spin
            tip={<IntlMessages id='products.addeditpriceprod.savebook' />}
            spinning={getSpinLoader}
            size='large'
          ></Spin>

          <div className='tab-body-parent'>
            <Card title=''>
              <Tabs
                defaultActiveKey='1'
                size='large'
                onChange={handleInventoryTabChange}
              >
                {InventoryGeneralStatuse.map((e, index) => {
                  return (
                    <TabPane
                      tab={<IntlMessages id={e.DisplayName} />}
                      key={e.Key}
                    >
                      <Card title=''>
                        {getLoader ? (
                          <Skeleton count={7} height={35} />
                        ) : (
                          <Table
                            className='gx-table-responsive'
                            columns={columnsInventoryCountList}
                            dataSource={getInventoryListData}
                            pagination={getPagination}
                            onChange={tableObj =>
                              handleTableChange(tableObj, e.Name)
                            }
                          />
                        )}
                      </Card>
                    </TabPane>
                  )
                })}
              </Tabs>
            </Card>
          </div>
        </div>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}
export default InventoryCountList
